import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Presentation icon — flip chart / easel stand outline.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const PresentationIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M18.1544 5.41055V3.68002C18.1543 2.98805 17.5956 2.42563 16.8986 2.42563H3.09897C2.40705 2.42572 1.84467 2.98309 1.84458 3.68002V5.41055C1.84426 5.80395 1.52524 6.12337 1.13176 6.12337C0.738282 6.12337 0.419266 5.80395 0.418945 5.41055V3.68002C0.419035 2.19125 1.62419 1.00009 3.09897 1H16.8986C18.3875 1 19.58 2.20519 19.5801 3.68002V5.41055C19.5797 5.80375 19.2604 6.12303 18.8672 6.12337C18.4738 6.12337 18.1547 5.80395 18.1544 5.41055Z"
      fill="currentColor"
    />
    <path
      d="M9.28613 18.2882V2.50188C9.28613 2.1082 9.60527 1.78906 9.99895 1.78906C10.3926 1.78906 10.7118 2.1082 10.7118 2.50188V18.2882C10.7118 18.6819 10.3926 19.0011 9.99895 19.0011C9.60527 19.0011 9.28613 18.6819 9.28613 18.2882Z"
      fill="currentColor"
    />
    <path
      d="M13.7426 17.5742C14.1363 17.5742 14.4554 17.8934 14.4554 18.287C14.4554 18.6807 14.1363 18.9999 13.7426 18.9999H6.25383C5.86015 18.9999 5.54102 18.6807 5.54102 18.287C5.54102 17.8934 5.86015 17.5742 6.25383 17.5742H13.7426Z"
      fill="currentColor"
    />
  </svg>
);

export default PresentationIcon;
